import React from 'react';

const ParaComponent = ({ data }) => {
  const { headline, description } = data?.fields;
  const { content } = description?.content[0];
  return (
    <div
      className={`
      para-container 
      d-flex 
      flex-column 
      align-items-md-center
      text-lg-center text-left`}
    >
      {headline && <span className='para-heading'>{headline}</span>}
      {content.map(para => (
        <span className='p1'>{para?.value}</span>
      ))}
    </div>
  );
};

export default ParaComponent;
